<script>
export default {
  components: {},
  methods: {
    buyForFree: async function () {
      this.pending = true;
      let result;
      try {
        result = await this.handler.action(this.plan['buy_for_free'], "call");
      } catch (e) {
        this.pending = false;
        return;
      }
      this.pending = false;
      if (result["#result"]["result"]) {
        this.$emit("proceed");
      }
    },
    selectCountry: function (c) {
      this.country = c;
    },
  },
  props: ["component", "handler", "plan"],
  data: function () {
    return {
      pending: false,
      companyName: "",
      vat: "",
      address: "",
      postalCode: "",
      city: "",
      country: "",
      phoneNumber: "",
      creditCardName: "",
      creditCardNumber: "",
      creditCardDate: "",
      creditCardCVC: "",
    };
  },
  computed: {},
  mounted: function () {
    if (!this.plan) {
      this.$emit("reset");
    }
  },
};
</script>

<template>
  <div class="plan-tunnel-proceed-component">
    <div class="main-title">{{ $vt("Proceed to payment") }}</div>
    <div class="plan-tunnel-proceed-content">
      <div class="plan-tunnel-proceed-chosen-plan">
        <component v-bind:is="plan.meta.type" :component="plan" :handler="handler" :chosen="true"
          :do-not-show-expired="true">
        </component>
        <f-button type="link" @click="$emit('reset')"><f-icon icon="fa6-arrow-left"></f-icon> {{ $vt("Back") }}</f-button>
      </div>
      <FFadeTransitionOutIn>
        <StripeLoader class="information" v-if="plan.stripe_component && (plan.extendable || plan.upgradable)"
          :component="plan.stripe_component" :handler="handler" />
        <div v-else class="information plan-no-longer-available">
          <FHint icon="fa6-warning" type="negative">
            <template #title>
              {{ $vt("This plan is no longer available.") }}
            </template>
            <template #message>
              {{ $vt("Please select a different plan.") }}
            </template>
          </FHint>
          <FHint icon="fa6-info">
            <template #message>
              {{ $vt("This plan may have been purchased in another window, or your plan expired during the payment process") }}
            </template>
          </FHint>
        </div>
      </FFadeTransitionOutIn>
      <FButton v-if="plan['buy_for_free'] && plan['buy_for_free']['#actions']" @click="buyForFree" type="danger"
        style="writing-mode: vertical-rl">
        {{ $vt("Buy for free") }}
      </FButton>
    </div>
  </div>
</template>

<style lang="scss">
.plan-tunnel-proceed-component {
  display: flex;
  flex-direction: column;
  gap: 32px;

  .plan-tunnel-proceed-content {
    display: flex;
    gap: 32px;

    .plan-tunnel-proceed-chosen-plan {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .f-button {
        color: var(--white-a75);
        text-align: center;
        font-family: Lato;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 110%;

        /* 26.4px */
        &:hover {
          text-decoration: none;
        }
      }
    }

    .information {
      width: 950px;
    }

    .plan-no-longer-available {
      background-color: var(--black);
      padding: 16px;
      border-radius: 8px;
      display: flex;
      gap: 16px;
      flex-direction: column;
    }
  }
}
</style>